import React from "react";

export const BackIcon = () => (
  <svg viewBox="0 0 100 100" width="10" height="10">
    <path d="M69,97.5c-2.4,0-4.9-0.9-6.7-2.8l-38-38c-3.7-3.7-3.7-9.7,0-13.5l38-38c3.7-3.7,9.7-3.7,13.5,0s3.7,9.7,0,13.5L44.5,50    l31.3,31.3c3.7,3.7,3.7,9.7,0,13.5C73.9,96.6,71.4,97.5,69,97.5z"></path>
  </svg>
);
